import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Link } from 'react-router-dom'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import LaunchIcon from '@mui/icons-material/Launch'

export const Column = styled(({ margin, padding, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    display: flex;

    @media (max-width: 390px) {
      width: 100%;
    }

    @media (min-width: 390px) and (max-width: 600px) {
      width: 50%;
    }

    ${props => props.theme.breakpoints.up('sm')} {
      margin: 0 0 14px 0;
    }
    ${props => props.theme.breakpoints.up('md')} {
      margin: 14px 0 0px 0;
    }
  }
`

export const ColumnOpenData = styled(({ padding, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-evenly;
    width: 100%;

    @media (max-width: 390px) {
      flex-direction: column;
      height: 200px;
      margin: 10px 0 10px 0;
    }

    @media (min-width: 390px) and (max-width: 600px) {
      flex-direction: row;
      margin: 20px 0 30px 0;
      width: 100%;
    }

    ${props => props.theme.breakpoints.only('sm')} {
      flex-direction: column;
    }
  }
`

export const DownloadPDFButton = styled(Link)`
  align-items: center;
  background-color: ${props => props.theme.palette.gray[95]};
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 4px;
  color: ${props => props.theme.palette.gray[50]};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  height: 60px;
  justify-content: center;
  line-height: 18px;
  padding: 12px 5px 12px 16px;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  text-decoration: none;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    color 0.15s ease-in-out;
  user-select: none;
  width: 100%;

  @media (max-width: 390px) {
    padding: 12px 75px 12px 18px;
    width: 100%;
  }

  @media (min-width: 390px) and (max-width: 600px) {
    padding: 13px 20px 11px 8px;
  }

  ${props => props.theme.breakpoints.only('sm')} {
    justify-content: left;
    padding: 12px 10px 12px 16px;
  }
  ${props => props.theme.breakpoints.up('lg')} {
    justify-content: left;
    padding: 12px 75px 12px 18px;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.blue[50.4]};
    outline: 0;
  }

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[50]};
    border-color: ${props => props.theme.palette.blue[50]};
    color: ${props => props.theme.palette.brand.white};

    & svg {
      color: ${props => props.theme.palette.brand.white};
    }
  }
`

export const DownloadIcon = styled(FileDownloadIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.gray[50]};
    height: 34px;
    vertical-align: bottom;

    ${props => props.theme.breakpoints.up('sm')} {
      margin-right: 10px;
    }

    &:hover {
      color: ${props => props.theme.palette.brand.white};
    }
  }
`

export const InfoOpenDataButton = styled(Link)`
  align-items: center;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.palette.custom.gray[20.2] : theme.palette.custom.blue[50.1]};
  border: ${({ disabled, theme }) => (disabled ? 'none' : `1px solid ${theme.palette.blue[50]}`)};
  border-radius: 4px;
  color: ${({ disabled, theme }) => (disabled ? theme.palette.brand.white : theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  height: 60px;
  justify-content: center;
  line-height: 18px;
  padding: 12px 5px 12px 16px;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  text-decoration: none;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    color 0.15s ease-in-out;
  user-select: none;
  width: 100%;

  @media (max-width: 390px) {
    padding: 12px 75px 12px 18px;
    width: 100%;
  }

  @media (min-width: 390px) and (max-width: 600px) {
    margin-right: 14px;
    padding: 13px 10px 11px 8px;
  }

  ${props => props.theme.breakpoints.only('sm')} {
    justify-content: left;
    padding: 12px 10px 12px 16px;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    justify-content: left;
    padding: 12px 75px 12px 18px;
  }

  &:focus {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.blue[50.4]};
    outline: 0;
  }

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[50]};
    border-color: ${props => props.theme.palette.blue[50]};
    color: ${props => props.theme.palette.brand.white};

    & svg {
      color: ${props => props.theme.palette.brand.white};
    }
  }
`

export const LaunchOpenDataIcon = styled(LaunchIcon)`
  margin: 0 8px;
  width: 24px;

  ${props => props.theme.breakpoints.up('sm')} {
    margin: 0 19px 0 8px;
  }

  &:hover {
    color: ${props => props.theme.palette.brand.white};
  }
`
